import {
  doGetQuery,
  doPostQuery,
  doPutQuery,
  doDeleteQuery,
  doRawQuery,
  ACCESS_TOKEN_STORAGE,
  calcApiUrl,
} from './utils';

export const apiGetDashboard = (): Promise<TDashboard> =>
  doGetQuery<TDashboard>(`users/dashboard`);

export const apiAddUser = async (user: TUserUpdate): Promise<string> => {
  const { userUid } = await doPostQuery<{ userUid: string }>(
    `users/user`,
    null,
    {
      user: {
        login: user.login,
        email: user.email || null,
        isAdmin: user.isAdmin,
        newPassword: user.newPassword,
      },
    }
  );
  return userUid;
};

export const apiUpdateUser = async (
  userUid: string,
  user: TUserUpdate
): Promise<void> => {
  await doPutQuery<{ userUid: string }>(`users/user/${userUid}`, null, {
    user: {
      login: user.login,
      email: user.email || null,
      isAdmin: user.isAdmin,
      oldPassword: user.oldPassword,
      newPassword: user.newPassword,
    },
  });
};

export const apiDeleteUser = async (userUid: string) =>
  await doDeleteQuery<void>(`users/user/${userUid}`);

export const apiGetUser = (userUid: string): Promise<TUser> =>
  doGetQuery<TUser>(`users/user/${userUid}`);

export const apiGetUsers = async () =>
  await doGetQuery<TRichUser[]>(`users/list`);

export const apiGetResource = async (resourceUid: string): Promise<string> => {
  const urlPath = `users/resource/${resourceUid}`;

  if (ACCESS_TOKEN_STORAGE === 'cookie') {
    // We can use the resource URL directly because the cookies can be is sent
    // from <img/>-like tags. So the server can check the user's permissions.
    return calcApiUrl(urlPath);
  }

  // It's quite a different story with the authorization header.
  const response = await doRawQuery({ method: 'GET', path: urlPath });
  if (!response.ok) {
    throw new Error(`Failed to get resource: ${response.statusText}`);
  }

  return URL.createObjectURL(await response.blob());
};
